import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { AI_CHECKOUT_CUSTOM_CSS_API } from '../../constants/central-api';

export default async function delete_custom_css_by_integration_key_api_call(
  integrationKey: string,
  customCSSElementId: string
) {
  const accessToken = store.getState().auth.authorization.accessToken;
  const isWhiteLabel = store.getState().UI?.isWhiteLabel;
  let sellerToken: string;
  if (isWhiteLabel) {
    sellerToken = accessToken?.currentWhiteLabelSellerToken;
  } else {
    sellerToken = accessToken?.sellerToken;
  }

  const requestInfo: RequestInfo = {
    url: `${AI_CHECKOUT_CUSTOM_CSS_API(integrationKey)}/${customCSSElementId}`,
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'DELETE_CUSTOM_CSS_BY_INTEGRATION_KEY';
  const customMsg = 'Custom CSS deleted successfully';

  const res = await asyncHandler(requestInfo, actionType, customMsg, false);

  if (res?.data?.data === null) {
    return true;
  }
}
